import { manufacturerListCRUDUrl, manufacturerListGetUrl } from "../constants/apis";
import axios from "axios";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getManufacturers = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(manufacturerListGetUrl + `${query || ""}`, config);

    return response;
};

export const postManufacturer = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(manufacturerListCRUDUrl, data, config);
    return response;
};

export const patchManufacturer = async ({ data, id }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.patch(manufacturerListCRUDUrl + id + "/", data, config);
    return response;
};
